import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import LinearProgress from '@mui/material/LinearProgress';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import PrintPage from '../common/print_page';
import LocalDate from '../common/convert_to_local';
import SimpleAlert from '../common/alert_message';
import useDrawerHistory from '../hooks/useDrawerHistory';
import ConversationView from './ConversationView';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenDialog = ({ openView, handleCloseView, viewToDo }) => {

  // Manage browser history for back button behavior
  useDrawerHistory(openView, handleCloseView, 'fullscreen-dialog');

  if (viewToDo?.title === undefined) {
    return null;
  }
  const { id, title, description, listName, isDone, dateTimeToDoToDo, dateDone_utc, notes, steps, percentDone, responders, conversation } = viewToDo;

  return (
    <div>
      <Dialog
        fullScreen
        open={openView}
        onClose={() => { }}
        TransitionComponent={Transition}>
        <AppBar position="sticky" sx={{ backgroundColor: '#3a1a5a' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseView}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{ flexGrow: 1, padding: 3, width: '100%', maxWidth: '100%' }} >

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Item>
                {dateDone_utc ? <p> <SimpleAlert textMessage={<LocalDate text="Date completed - " utcDate={dateDone_utc} />}/> </p> : ""}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 2, flexWrap: 'wrap' }}>
                  <Typography variant="h6" component="div">
                    {listName ? `${listName} / ` : ""}
                    {title}
                    {dateTimeToDoToDo && dateTimeToDoToDo.length > 0 && (`| Do ToDo On: ${new Date(dateTimeToDoToDo).toLocaleDateString()}`)}
                  </Typography>
                  {isDone && <Chip label="Completed" color="success" size="small" />}
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item><LinearProgress variant="determinate" value={percentDone} /></Item>
            </Grid>
            <Grid item xs={12} sx={{ width: '100%' }}>
              <Item sx={{ width: '100%' }}>
                <List sx={{ width: '100%' }}>
                  <ListItem>
                    <ListItemText primary="Description" secondary={description} sx={{ whiteSpace: 'pre-line', width: '100%' }} />
                  </ListItem>
                </List>
                <List sx={{ width: '100%' }}>
                  <ListItem>
                    <Typography variant="h6" component="div">
                      Notes
                    </Typography>
                  </ListItem>
                  {notes?.map((note, index) => (
                    <ListItem key={`noteItem_${index}`} sx={{ width: '100%' }}>
                      <ListItemText key={`note_${index}`} primary={note.title} secondary={note.note} sx={{whiteSpace: "pre-line", width: '100%'}}/>
                    </ListItem>
                  ))}
                </List>
                {steps?.length > 0 && (
                  <List sx={{ width: '100%' }}>
                    <ListItem>
                      <Typography variant="h6" component="div">
                        Steps
                      </Typography>
                    </ListItem>
                    {steps.map((step, index) => (
                      <ListItem key={`stepItem_${index}`} sx={{ width: '100%' }}>
                        <ListItemText
                          key={`step_${index}`}
                          primary={`${index + 1}. ${step.step}`}
                          sx={{ whiteSpace: "pre-line", width: '100%' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
                {responders?.length > 1 && (
                  <List sx={{ width: '100%' }}>
                    <ListItem>
                      <Typography variant="h6" component="div">
                        Participants
                      </Typography>
                    </ListItem>
                    {responders.map((responder, index) => (
                      <ListItem key={`responderItem_${index}`} sx={{ width: '100%' }}>
                        <ListItemText
                          key={`responder_${index}`}
                          primary={`${responder.name} (${responder.role})`}
                          secondary={responder.email}
                          sx={{ width: '100%' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
                {conversation?.length > 0 && responders?.length > 1 && (
                  <Box sx={{ width: '100%', mt: 2 }}>
                    <ConversationView
                      todoId={id}
                      conversation={conversation}
                      responders={responders}
                    />
                  </Box>
                )}
              </Item>
            </Grid>
          </Grid>
          <PrintPage />
        </Box>
      </Dialog>

    </div>
  );
}

export default FullScreenDialog